import { Progress } from "antd";

interface IPurchaseOrderPaymentProgressProps {
  total: number;
  current: number;
}
export default function PurchaseOrderPaymentProgress({ total, current }: IPurchaseOrderPaymentProgressProps) {
  return <Progress percent={current / total * 100} showInfo={false} />;
}
